// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { SiKeycloak as RawSiKeycloak } from "react-icons/si";
export const SiKeycloak = /* @__PURE__ */ createIcon(RawSiKeycloak, "SiKeycloak", 0);
